// Clipboard access can be restricted by embedded previews and mobile browser permissions.
// This fallback still requires the initiating user click and never copies unrelated fields.
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(text); return true; }
  } catch { /* Try the selected-text path before requiring manual copying. */ }
  const previous = document.activeElement as HTMLElement | null;
  const selection = window.getSelection();
  const ranges = selection ? Array.from({ length: selection.rangeCount }, (_, i) => selection.getRangeAt(i).cloneRange()) : [];
  const area = document.createElement('textarea');
  area.value = text; area.readOnly = true;
  area.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;padding:0;border:0;';
  document.body.appendChild(area);
  try { area.focus({ preventScroll: true }); area.select(); area.setSelectionRange(0, text.length); return document.execCommand('copy'); }
  catch { return false; }
  finally {
    area.remove(); previous?.focus({ preventScroll: true });
    if (selection) { selection.removeAllRanges(); ranges.forEach(r => selection.addRange(r)); }
  }
}